// ── Game Configuration Constants ──
// Tunable values extracted from systems code. Change these to adjust
// game feel without touching system logic.

export const SCENE = {
  // Orbit
  ORBIT_SPEED: 0.015,                 // radians/sec
  ORBIT_MIN_RADIUS_SHIP: 20,          // game units
  ORBIT_PLANET_CLEARANCE: 1.625,      // multiplier on planet radius

  // Approach stop distances
  APPROACH_PLANET_CLEARANCE: 1.75,    // multiplier on planet radius
  APPROACH_SHIP_MIN_STOP: 22,         // game units
  APPROACH_MIN_STOP_RATIO: 0.3,       // fraction of distance

  // Evasive maneuvers
  EVASIVE_DURATION: 8,                // seconds
  EVASIVE_JINK_COUNT: 6,
  EVASIVE_JINK_RADIUS_MIN: 5,        // game units
  EVASIVE_JINK_RADIUS_MAX: 15,       // game units
  EVASIVE_JINK_Y_RANGE: 4,           // game units

  // Heading
  HEADING_TURN_DURATION: 12,          // seconds to complete a turn

  // System edge (retreat destination — well beyond outermost orbital body)
  SYSTEM_EDGE: { x: -4500, y: 0, z: 0 },
} as const;

export const ORDERS = {
  SCAN_DURATION: 10,                  // seconds
  SHUTTLE_SPEED: 4,                   // game units/sec
  PROBE_SPEED: 8,                     // game units/sec
  MIN_MOVEMENT_DURATION: 4,           // seconds
  MIN_LAUNCH_DURATION: 5,             // seconds
} as const;

// Impulse speed values in game units per second.
// Single source of truth — used by IntentResolver (timer durations)
// and SceneCommandExecutor (animation durations).
export const IMPULSE_SPEEDS: Record<string, number> = {
  impulse_slow: 1.2,
  impulse_half: 2.5,
  impulse_full: 5,
  warp: 50,
};

export const COMBAT = {
  WEAPONS_RANGE: 150,          // game units — max engagement distance
  FIRE_COOLDOWN_MIN: 8,        // seconds between shots per entity
  FIRE_COOLDOWN_MAX: 12,
  HIT_CHANCE_BASE: 0.7,        // 70% hit rate normally
  HIT_CHANCE_EVASIVE: 0.35,    // halved during evasive maneuvers
  SEVERITY_THRESHOLDS: [0.4, 0.75, 0.95, 1.0] as readonly number[], // light, moderate, heavy, critical
} as const;

// Intent speed labels → impulse keys
export const SPEED_LABEL_TO_IMPULSE: Record<string, string> = {
  slow: "impulse_slow",
  half: "impulse_half",
  full: "impulse_full",
  warp: "warp",
};
